export enum ReadingUnitType {
    Sentence = 'SENTENCE',
    Word = 'WORD',
}

export enum ReadingBase {
    Continuous = 'CONTINUOUS',
    Manual = 'MANUAL'
}

export enum ReadingEcho {
    Sentence = 'SENTENCE',
    Word = 'WORD',
    Character = 'CHARACTER'
}

export enum ReadingItemType {
    Text = 'Text',
    Sentence = 'Sentence',
    Word = 'word',
}

export enum TxtItemType {
    Word = 'Word',
    Punctuation = 'Punctuation',
    SingleDigit = 'SingleDigit',
    NumberInt = 'NumberInt',
    NumberFloat = 'NumberFloat'
}

export enum ReadingMode {
    Hover = 'Hover',
    Selection = 'Selection',
    ClickToRead = 'ClickToRead',
    ClickToPlay = 'ClickToPlay',
    RectangleSelection = 'RectangleSelection',
}

export enum SoundStatus {
    WaitingForSound = 'WaitingForSound',
    Playing = 'Playing',
    Stopped = 'Stopped',
    Paused = 'Paused',
    Error = 'Error',
}

export enum AudioCaprureStatus {
    Capturing = 'Capturing',
    Stopped = 'Stopped',
    Error = 'Error',
}

export enum ReaderStatus {
    Speaking = 'Speaking',
    Stopped = 'Stopped',
    Paused = 'Paused',
    ReadingToPause = 'ReadingToPause'
}

export enum ReadingBoundary {
    Word = 'Word',
    Text = 'Text'
}

export enum SpeakingJobType {
    Document = 'Document',
    SimpleText = 'SimpleText',
    Tooltip = 'Tooltip',
    MenuItem = 'MenuItem',
    AltText = 'AltText', // alternate text of pdf 'reading zones'
    Link = 'Link', // for epub links
}

export enum VoiceSpeed {
    VerySlow = 'VERYSLOW',
    Slow = 'SLOW',
    Normal = 'NORMAL',
    Fast = 'FAST',
    VeryFast = 'VERYFAST'
}

export enum NavigationDirection {
    Next = 'Next',
    Previous = 'Previous',
}
